import { Permission } from '../acl/permission';

export enum Feature {
  EXPORT_REWARDS = 'EXPORT_REWARDS',
  PROGRAM = 'PROGRAM',
  EMBED = 'EMBED',
  EARNING_RULE = 'EARNING_RULE',
  BURNING_RULE = 'BURNING_RULE',
  REWARD = 'REWARD',
  PROMOCODE = 'PROMOCODE',
  LEVEL_CONFIG = 'LEVEL_CONFIG',
  LEVEL = 'LEVEL',
  TEMPLATE = 'TEMPLATE',
  INCOMING_WEBHOOK = 'INCOMING_WEBHOOK',
  OUTGOING_WEBHOOK = 'OUTGOING_WEBHOOK',
  BLOCKING = 'BLOCKING',
  UNBLOCKING = 'UNBLOCKING',
  PARTICIPANT = 'PARTICIPANT',
  OFFER_REWARD = 'OFFER_REWARD',
  ADJUST_BALANCE = 'ADJUST_BALANCE',
  ADJUST_LEVEL = 'ADJUST_LEVEL',
  CURRENCY = 'CURRENCY',
  REPORT = 'REPORT',
  EVENT_REPORT = 'EVENT_REPORT',
  CUSTOM_KEY = 'CUSTOM_KEY',
  REFERRAL = 'REFERRAL',
  DOMAINS_MANAGEMENT = 'DOMAINS_MANAGEMENT',
  DELETE_MEMBER = 'DELETE_MEMBER',
  RESET_PROGRAM = 'RESET_PROGRAM',
  TEST_USERS = 'TEST_USERS',
  SEE_PROGRAM_DELETION = 'SEE_PROGRAM_DELETION',
  PROGRAM_ACCESS = 'PROGRAM_ACCESS',
  PROGRAM_LOGIN = 'PROGRAM_LOGIN',
  LOGIN_PAGE = 'LOGIN_PAGE',
  SEE_KC_ID = 'SEE_KC_ID',
  EXPORT_PROFILES = 'EXPORT_PROFILES',
  TEMPLATE_JS = 'TEMPLATE_JS',
  TEMPLATE_JSON = 'TEMPLATE_JSON',
  WEEKLY_EXPIRATION = 'WEEKLY_EXPIRATION',
  DEV_DOMAIN = 'DEV_DOMAIN',
  RULES_IMPORT_EXPORT = 'RULES_IMPORT_EXPORT',
  INTERACTION = 'INTERACTION',
}

export type FeatureMappingType = boolean | Permission[];

export interface SimpleFeatureMappingData<T extends FeatureMappingType> {
  enabled: T;
}

export interface ReadWriteFeatureMappingData<T extends FeatureMappingType> {
  read: T;
  write: T;
}

export interface ReadWritePublishFeatureMappingData<T extends FeatureMappingType>
  extends ReadWriteFeatureMappingData<T> {
  publish: T;
}

export interface ReadWriteDeleteFeatureMappingData<T extends FeatureMappingType>
  extends ReadWriteFeatureMappingData<T> {
  remove: T;
}

export interface ReadWriteDeleteRestoreFeatureMappingData<T extends FeatureMappingType>
  extends ReadWriteDeleteFeatureMappingData<T> {
  restore: T;
}
